import React from 'react';
import PropTypes from 'prop-types';
import BreadcrumbsItem from './BreadcrumbsItem';
import FadedOneLineText from '../../../../components/FadedOneLineText';

const Breadcrumbs = ({ items, baseCls, ...props }) => (
  <FadedOneLineText {...props}>
    <ul
      className={baseCls}
      itemScope
      itemType="http://schema.org/BreadcrumbList"
    >
      {items?.map(({ title, link }, index) => {
        const separator = items.length - 1 !== index ? ', ' : null;
        return (
          <React.Fragment key={title}>
            <BreadcrumbsItem link={link} title={title} position={index + 1} />
            {separator && <li>{separator}</li>}
          </React.Fragment>
        );
      })}
    </ul>
  </FadedOneLineText>
);

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  baseCls: PropTypes.string.isRequired,
};

export default Breadcrumbs;
